import { gql, useLazyQuery } from "@apollo/client";

export const QUERY_GET_ACTION_FILES = gql`
  query getActionFiles($actionId: ID!, $pageNumber: Int, $pageSize: Int) {
    getActionFiles(
      input: {
        actionId: $actionId
        pageNumber: $pageNumber
        pageSize: $pageSize
      }
    ) {
      actionFiles {
        actionFileType
        file {
          __typename
          name
          versionId
          revision
          validity {
            overallValidityStatus
          }
          repo {
            name
            id
          }
        }
      }
      totalCount
    }
  }
`;

export function useGetActionFilesQuery() {
  const [
    getActionFiles,
    {
      data: actionFiles,
      loading: isActionFilesLoading,
      error: errorActionFiles,
      refetch: refetchActionFiles
    }
  ] = useLazyQuery(QUERY_GET_ACTION_FILES, {
    fetchPolicy: "no-cache"
  });

  return {
    getActionFiles,
    actionFiles,
    isActionFilesLoading,
    errorActionFiles,
    refetchActionFiles
  };
}
